export type Drama = {
  id: string;
  title: string;
  subtitle: string;
  category: string;
  tags: string[];
  rating: number;
  heat: number;
  episodes: number;
  year: number;
  status: string;
  audience: string;
  cover: string;
  synopsis: string;
  highlights: string[];
  similar: string[];
};

export type Genre = {
  slug: string;
  name: string;
  count: number;
  desc: string;
  image: string;
};

export const siteInfo = {
  name: "黑料剧场",
  slogan: "短剧排行榜 · 同款推荐 · 新剧速递",
  description:
    "汇总黑料短剧排行榜、热门短剧与新剧推荐，按口味挑片不踩雷，同类好剧持续更新。",
  email: "hello@heiliao-theater.cn",
  updateNote: "每日 10:00 更新榜单与上新",
  stats: [
    { label: "收录短剧", value: "3,280+" },
    { label: "覆盖口味", value: "6 大类" },
    { label: "日均更新", value: "20+ 部" },
    { label: "读者评分", value: "4.8 / 5" },
  ],
};

export const genres: Genre[] = [
  {
    slug: "haomen",
    name: "豪门恩怨",
    count: 862,
    desc: "家族秘辛、真假身份、利益与情感的正面交锋，一集一个反转。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20grand%20mansion%20at%20night%20with%20warm%20golden%20window%20lights%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-haomen&orientation=squarish",
  },
  {
    slug: "chongsheng",
    name: "重生逆袭",
    count: 743,
    desc: "重来一次的人生，把遗憾逐个翻盘，爽点密集、情绪上头。",
    image:
      "https://readdy.ai/api/search-image?query=Sunrise%20glow%20over%20a%20misty%20city%20skyline%20seen%20from%20a%20high%20window%2C%20hopeful%20warm%20light%2C%20dramatic%20moody%20atmosphere%2C%20deep%20shadows%2C%20warm%20amber%20color%20grading%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-chongsheng&orientation=squarish",
  },
  {
    slug: "dushi",
    name: "都市情感",
    count: 918,
    desc: "写字楼与出租屋之间的爱与选择，真实细腻又步步揪心。",
    image:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20with%20umbrellas%20and%20wet%20pavement%20reflections%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20red%20and%20bronze%20color%20grading%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-dushi&orientation=squarish",
  },
  {
    slug: "xuanyi",
    name: "悬疑复仇",
    count: 655,
    desc: "线索层层递进，反派逐个现形，看到最后才懂全部真相。",
    image:
      "https://readdy.ai/api/search-image?query=Shadowed%20long%20corridor%20lit%20by%20a%20single%20warm%20lamp%2C%20tense%20mysterious%20atmosphere%2C%20deep%20shadows%2C%20warm%20amber%20and%20bronze%20color%20grading%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-xuanyi&orientation=squarish",
  },
  {
    slug: "zhichang",
    name: "职场博弈",
    count: 512,
    desc: "会议室里的攻守进退，实力与手段同样重要，节奏干脆利落。",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20glass%20office%20tower%20interior%20at%20night%20with%20city%20lights%20outside%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20bronze%20and%20amber%20color%20grading%2C%20film%20grain%2C%20cinematic%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-zhichang&orientation=squarish",
  },
  {
    slug: "tianchong",
    name: "甜宠日常",
    count: 700,
    desc: "轻松解压的下饭剧，节奏轻快、糖分充足，适合睡前来一集。",
    image:
      "https://readdy.ai/api/search-image?query=Cozy%20warm%20cafe%20table%20with%20two%20coffee%20cups%20and%20soft%20window%20light%2C%20intimate%20golden%20glow%2C%20gentle%20cinematic%20color%20grading%2C%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=480&height=480&seq=hl-genre-tianchong&orientation=squarish",
  },
];

export const dramas: Drama[] = [
  {
    id: "haomen-heiliao",
    title: "《豪门黑料曝光》",
    subtitle: "一份被藏了二十年的账本，撕开了所有人的体面",
    category: "豪门恩怨",
    tags: ["豪门", "黑料", "反转密集"],
    rating: 9.4,
    heat: 98,
    episodes: 82,
    year: 2026,
    status: "已完结",
    audience: "喜欢家族秘辛与连续反转的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20an%20elegant%20woman%20in%20a%20dark%20luxury%20mansion%20hallway%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-01&orientation=portrait",
    synopsis:
      "沈家老爷子病重，一份被刻意藏起来的旧账本突然出现在灵堂之上。账本上每一个名字，都对应着沈家这些年不愿被提起的往事。一直被视为外人的沈知晚被迫卷入这场体面与人心的较量，她本以为只是想拿回属于自己的东西，没想到每翻开一页，就把自己推得更深。当所有人都以为黑料曝光只是开始，真正的秘密才刚刚露出边角。",
    highlights: [
      "开篇即高潮：灵堂账本现世，十分钟交代全部人物关系",
      "反转密度高：平均每三集一次立场调转，节奏毫不拖沓",
      "人物不脸谱化：反派也有自己的理由，看完会沉默一下",
    ],
    similar: ["qianjin-nixi", "zongcai-shenfen", "jiaqianjin-xiabanchang"],
  },
  {
    id: "chongsheng-zhannan",
    title: "《重生之我把渣男送上热搜》",
    subtitle: "重来一次，她决定先把自己活明白",
    category: "重生逆袭",
    tags: ["重生", "逆袭", "爽剧"],
    rating: 9.2,
    heat: 95,
    episodes: 76,
    year: 2026,
    status: "已完结",
    audience: "想看不憋屈、情绪出口清晰的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20powerful%20young%20woman%20standing%20in%20a%20rain%20soaked%20city%20street%20at%20night%20with%20neon%20reflections%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-02&orientation=portrait",
    synopsis:
      "林昭在婚礼当天才发现自己被算计得彻底。再次睁眼，她回到了三年前那个可以重新选择的岔路口。这一次她没有急着报复，而是先把工作、存款和底气一件件握回手里。当昔日的对手还在用老办法试探，她已经换了一条完全不同的路。爽感不是来自喊口号，而是来自每一个漂亮又克制的回击。",
    highlights: [
      "爽点合理：每一步反击都有铺垫，看着解气又不悬浮",
      "成长线清楚：从被动挨打到掌控节奏，人物弧光完整",
      "台词有记忆点：适合二刷找彩蛋",
    ],
    similar: ["tijia-xinniang", "lihun-dingliu", "jiaqianjin-xiabanchang"],
  },
  {
    id: "qianjin-nixi",
    title: "《千金逆袭：真相不止一个》",
    subtitle: "被换掉的人生，她一寸一寸夺回来",
    category: "都市情感",
    tags: ["真假千金", "都市", "复仇"],
    rating: 9.0,
    heat: 92,
    episodes: 88,
    year: 2025,
    status: "已完结",
    audience: "喜欢身份悬念与情感拉扯的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20an%20heiress%20in%20an%20elegant%20evening%20gown%20in%20a%20grand%20ballroom%20with%20chandelier%20glow%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-03&orientation=portrait",
    synopsis:
      "二十年前的一场调换，让苏晚从云端跌进普通生活。当真相被一点点拼出来，她面对的是一场关于归属感的漫长拉锯。她想讨回公道，却也不愿伤害无辜的人。剧集把「逆袭」写成了选择题：是回到原本的位置，还是成为自己真正想成为的人。",
    highlights: [
      "情感浓度高：亲情线与成长线交织，不止是爽",
      "服化道精致：宴会、家宴场景对比强烈",
      "结局收得稳：没有硬拗大团圆",
    ],
    similar: ["haomen-heiliao", "jiaqianjin-xiabanchang", "zongcai-shenfen"],
  },
  {
    id: "yizhi-hunyue",
    title: "《一纸婚约藏不住》",
    subtitle: "她只想安静履约，他却步步紧逼",
    category: "都市情感",
    tags: ["先婚后爱", "都市", "双向奔赴"],
    rating: 8.8,
    heat: 90,
    episodes: 70,
    year: 2025,
    status: "已完结",
    audience: "喜欢慢热情感与日常细腻互动的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20bride%20in%20traditional%20red%20wedding%20attire%20in%20a%20candle%20lit%20ancient%20courtyard%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-04&orientation=portrait",
    synopsis:
      "一纸为长辈而签的婚约，让两个原本毫无交集的人住进了同一屋檐下。何穗守着界限，男主却总在细节里越线：雨天的伞、深夜的灯、没说出口的在意。没有狗血拉扯，全靠细节堆出的心动，适合一口气看到天亮。",
    highlights: [
      "细节写心动：一个眼神、一次让步都很戳",
      "节奏舒适：甜而不腻，日常感强",
      "配角出彩：长辈线贡献不少笑点",
    ],
    similar: ["shanhun-laogong", "qianjin-nixi", "tianchong"],
  },
  {
    id: "shoufu-dangan",
    title: "《首富的秘密档案》",
    subtitle: "所有人都以为他只是运气好",
    category: "悬疑复仇",
    tags: ["悬疑", "复仇", "权谋"],
    rating: 9.1,
    heat: 93,
    episodes: 84,
    year: 2026,
    status: "更新中",
    audience: "喜欢烧脑推理与层层揭示的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20confident%20man%20in%20a%20dark%20suit%20inside%20a%20secret%20archive%20room%20with%20scattered%20documents%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20amber%20and%20bronze%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-05&orientation=portrait",
    synopsis:
      "一份标着「归档」的旧档案，把一个白手起家的商业帝国重新推上风口。调查记者顾行在追查一桩十年前的旧案时发现，如今站在顶端的那个人，当年只是一个巧合里的幸存者。每一次接近真相，都有人抢先一步把线索抹掉。这一次，他决定不再退。",
    highlights: [
      "结构精巧：多线叙事，最后完美收束",
      "悬念留得刚好：每集结尾都想再点下一集",
      "氛围营造一流：镜头语言很有电影感",
    ],
    similar: ["chouwen-zhixia", "zongcai-shenfen", "lihun-dingliu"],
  },
  {
    id: "yinghou-reshou",
    title: "《影后她不想上热搜》",
    subtitle: "话题越多，她越想把戏演好",
    category: "职场博弈",
    tags: ["娱乐圈", "职场", "成长"],
    rating: 8.7,
    heat: 88,
    episodes: 68,
    year: 2025,
    status: "已完结",
    audience: "对娱乐圈生态与职业成长感兴趣的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20glamorous%20film%20star%20in%20a%20spotlight%20on%20a%20red%20carpet%20at%20night%20with%20camera%20flashes%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-06&orientation=portrait",
    synopsis:
      "刚拿下大奖的演员姜屿，最怕的不是没戏拍，而是被贴上「话题女星」的标签。团队催她蹭热度，她偏要钻进剧组磨一个不讨巧的角色。流量与实力的拉扯、同行的明枪暗箭，把一个只想好好演戏的人推到了聚光灯下。",
    highlights: [
      "行业感真实：拍戏日常与舆论博弈都很到位",
      "人物立得住：主角的坚持不圣母也不莽",
      "金句不少：关于「被看见」的表达很动人",
    ],
    similar: ["lihun-dingliu", "shoufu-dangan", "chongsheng-zhannan"],
  },
  {
    id: "shanhun-laogong",
    title: "《闪婚后老公藏不住了》",
    subtitle: "结婚三天，她发现丈夫身份不简单",
    category: "甜宠日常",
    tags: ["闪婚", "马甲", "甜宠"],
    rating: 8.9,
    heat: 91,
    episodes: 72,
    year: 2026,
    status: "更新中",
    audience: "喜欢轻松甜剧与身份反转的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20young%20couple%20in%20a%20cozy%20modern%20apartment%20near%20a%20window%20at%20dusk%2C%20warm%20intimate%20lighting%2C%20soft%20golden%20glow%2C%20gentle%20cinematic%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-07&orientation=portrait",
    synopsis:
      "领证那天，苏晚以为只是找个人搭伙过日子。可婚后这个「普通上班族」总在奇怪的地方露馅：随手签掉的黑卡、随口报出的地名、以及那些不肯细说的过去。甜归甜，悬念也没落下，越看越想知道他到底是谁。",
    highlights: [
      "甜中带钩：撒糖同时留马甲悬念",
      "互动自然：生活化台词很上头",
      "适合下饭：单集体量短，追起来没压力",
    ],
    similar: ["yizhi-hunyue", "zongcai-shenfen", "tianchong"],
  },
  {
    id: "tijia-xinniang",
    title: "《替嫁新娘掀翻身》",
    subtitle: "被推上花轿的那一刻，她就不再退让",
    category: "重生逆袭",
    tags: ["替嫁", "逆袭", "宅斗"],
    rating: 8.6,
    heat: 87,
    episodes: 80,
    year: 2025,
    status: "已完结",
    audience: "喜欢古风宅斗与逆袭线的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20determined%20woman%20in%20embroidered%20hanfu%20standing%20on%20a%20grand%20ancient%20staircase%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-08&orientation=portrait",
    synopsis:
      "本该出嫁的是嫡姐，被推上花轿的却是她。沈砚秋认下这桩婚事后，没有哭闹，而是把每一步都算得清清楚楚。府里的人都等着看她笑话，她却先一步站稳了脚跟。宅斗看得是手段，更看得是心气，这部剧两样都给你。",
    highlights: [
      "古风质感足：场景、服化统一在线",
      "宅斗节奏快：冲突密集但不乱",
      "女主够稳：不靠开挂靠布局",
    ],
    similar: ["chongsheng-zhannan", "jiaqianjin-xiabanchang", "qianjin-nixi"],
  },
  {
    id: "zongcai-shenfen",
    title: "《总裁的隐藏身份》",
    subtitle: "被看轻的日子里，他一直在等一个时机",
    category: "豪门恩怨",
    tags: ["身份反转", "商战", "爽感"],
    rating: 8.8,
    heat: 89,
    episodes: 74,
    year: 2025,
    status: "已完结",
    audience: "喜欢身份反转与商战博弈的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20mysterious%20businessman%20silhouetted%20against%20floor%20to%20ceiling%20windows%20of%20a%20skyscraper%20at%20night%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20amber%20and%20bronze%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-09&orientation=portrait",
    synopsis:
      "在公司里，他是那个谁都能使唤的普通职员。没人知道他每天下班后去的是另一栋楼。当旧对手再次出手，他不再隐藏底牌。商战部分写得扎实，反转都踩在人物动机上，看着很过瘾。",
    highlights: [
      "马甲揭晓爽感强：伏笔埋得早、收得稳",
      "商战不悬浮：交易与谈判逻辑自洽",
      "双线并行：职场与情感互相推进",
    ],
    similar: ["haomen-heiliao", "shoufu-dangan", "shanhun-laogong"],
  },
  {
    id: "lihun-dingliu",
    title: "《离婚后我成了顶流》",
    subtitle: "放下错的，才腾出手接住更好的",
    category: "职场博弈",
    tags: ["离婚", "重启", "女性成长"],
    rating: 9.0,
    heat: 94,
    episodes: 78,
    year: 2026,
    status: "已完结",
    audience: "想看独立成长与事业线爽感的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20stylish%20woman%20walking%20through%20a%20bright%20television%20studio%20backstage%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20amber%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-10&orientation=portrait",
    synopsis:
      "离婚协议签完那天，江晚宁把婚戒摘下，也把「某人的太太」这个称呼一起放下。她重新回到镜头前，从最小的角色做起。一步步走上来的时候，曾经轻视她的人才发现，她从来不是谁的附属。事业线与自我和解同时推进，看完很有力量。",
    highlights: [
      "事业线扎实：每一步上升都有代价",
      "情绪真实：低谷拍得不煽情但很戳",
      "结尾有力量：不靠爱情定义结局",
    ],
    similar: ["yinghou-reshou", "chongsheng-zhannan", "shoufu-dangan"],
  },
  {
    id: "chouwen-zhixia",
    title: "《丑闻之下》",
    subtitle: "真相被按下暂停键的第十年",
    category: "悬疑复仇",
    tags: ["悬疑", "丑闻", "群像"],
    rating: 9.3,
    heat: 96,
    episodes: 86,
    year: 2026,
    status: "更新中",
    audience: "喜欢群像叙事与深度悬疑的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20tense%20woman%20facing%20a%20crowd%20of%20reporters%20outside%20a%20courthouse%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-11&orientation=portrait",
    synopsis:
      "十年前的一桩旧闻，在所有人都快忘记的时候被重新翻出。当年在场的人各自走向不同的人生，如今又被同一件事拉回原点。每个人都记得一部分真相，而完整的那块拼图，藏在最不显眼的地方。群像写得好，越往后越上头。",
    highlights: [
      "群像立体：六个关键人物都有前史",
      "悬疑扎实：线索回收干净，没有强行反转",
      "后劲很足：看完会想再看一遍开头",
    ],
    similar: ["shoufu-dangan", "haomen-heiliao", "zongcai-shenfen"],
  },
  {
    id: "jiaqianjin-xiabanchang",
    title: "《假千金的下半场》",
    subtitle: "身份归还之后，她的人生才刚开始",
    category: "重生逆袭",
    tags: ["真假千金", "成长", "治愈"],
    rating: 8.5,
    heat: 85,
    episodes: 66,
    year: 2024,
    status: "已完结",
    audience: "喜欢成长治愈与身份议题的观众",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20vertical%20short%20drama%20poster%20of%20a%20poised%20young%20woman%20in%20a%20modern%20luxury%20hotel%20lobby%20at%20night%20with%20reflective%20marble%20floors%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20film%20grain%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=hl-drama-12&orientation=portrait",
    synopsis:
      "真相揭晓后，她从「千金」变回普通人，也被允许离开那个并不属于她的家。别人以为这是落幕，她却当作开场。她重新学习、重新交友、重新定义自己。没有复仇，只有把自己一点点拼回来的过程，温柔但有力量。",
    highlights: [
      "不靠撕：把重心放在自我重建上",
      "细腻治愈：日常戏份拍得舒服",
      "适合二刷：很多小细节第一次会错过",
    ],
    similar: ["qianjin-nixi", "tijia-xinniang", "chongsheng-zhannan"],
  },
];

export const testimonials = [
  {
    name: "阿栗",
    role: "追剧 3 年",
    text: "最怕点开一部剧发现不是自己的口味。这里每个口味底下都有同款推荐，挑片效率高太多了。",
  },
  {
    name: "夜航船",
    role: "通勤党",
    text: "榜单排序比较靠谱，热度高的不一定好看，但这里的口碑榜基本没踩过雷。",
  },
  {
    name: "小满",
    role: "内容爱好者",
    text: "喜欢它把「为什么好看」写清楚，而不只是甩一个分数，选片的时候心里有底。",
  },
];

export const faqs = [
  {
    q: "「黑料短剧」具体指什么类型的短剧？",
    a: "这里说的黑料短剧，指的是围绕家族秘辛、身份疑云、旧事曝光等题材展开的竖屏短剧。它们共同的特点是信息密度高、反转多、单集时长短，适合碎片时间观看。",
  },
  {
    q: "排行榜多久更新一次？",
    a: "热度榜和口碑榜每日 10:00 更新，新剧速递会在作品上线后 24 小时内补录。如果某部剧的评分在更新周期内出现明显波动，我们会复核后再调整名次。",
  },
  {
    q: "怎么找到和某部剧「同款类似」的短剧？",
    a: "每部剧的详情页底部都有「同款类似推荐」，按照题材、节奏和情绪基调做匹配。你也可以在排行榜页按口味筛选，快速找到同一类型的作品。",
  },
  {
    q: "评分是怎么算出来的？",
    a: "评分综合了剧情完成度、节奏紧凑度、表演与制作水准三个维度，由编辑团队按统一标准打分，并参考读者反馈动态校正，满分为 10 分。",
  },
  {
    q: "我没看过短剧，从哪一部开始比较合适？",
    a: "可以从「甜宠日常」或「都市情感」入手，这类作品门槛低、节奏舒适。如果你喜欢强情节，则建议直接从悬疑复仇类的口碑榜前列开始。",
  },
];